//export const BASE_URL = 'http://localhost:8080';
//export const BASE_URL = 'https://airfitness.azurewebsites.net';
export const BASE_URL = 'https://airfitness-6a7ef.ondigitalocean.app';